module.exports = __webpack_public_path__ + "img/idc_pic01.da99abc1.png";